/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// SMA-185 Q7. Hand-added, like the trainer route it answers: the remove-trainer
// command returns { removed }, wrapped by the command bus Either (see
// groupsControllerRemoveTrainerFromGroup200Response).
export interface RemoveTrainerResponse {
  removed?: boolean;
}
